module.exports = __webpack_public_path__ + "img/check-double.a8babf90.svg";